export default __webpack_public_path__ + "static/happy-woman-69a31119e5b0ef4afd392032ecd00123.png";